import {STATE_COMPLETED} from '../projects/constants';
import {STATE_OPEN} from '../projects/constants';

const initialState = {
  'byId': new Map(),
  'modalState': 'closed',
  'currentlyEditing': {},
  'lastSaved': {},
};

function gatherChildCategories(category, children) {
  for (const child of category.children) {
    if (child.type != 'category') {
      continue;
    }
    gatherChildCategories(child, children);
  }
  children.push(category);
}

function completeCategory(state, category) {
  const children = [];
  gatherChildCategories(category, children);
  for (const child of children) {
    child.track_project_state_id = STATE_COMPLETED;
    state.byId.set(child.id, child);
  }
  category.track_project_state_id = STATE_COMPLETED;
  state.byId.set(category.id, category);
  return {...state, byId: new Map([...state.byId])};
}

function reopenCategory(state, category) {
  category.track_project_state_id = STATE_OPEN;
  state.byId.set(category.id, category);
  if (category.parent_id != null) {
    const parent_category = state.byId.get(category.parent_id);
    parent_category.track_project_state_id = STATE_OPEN;
    state.byId.set(parent_category.id, parent_category);
  }
  return {...state, byId: new Map([...state.byId])};
}

function reopenProject(state, project) {
  if (project.track_project_category_id == null) {
    return state;
  }
  const category = state.byId.get(project.track_project_category_id);
  return reopenCategory(state, category);
}

function deleteCategory(state, category) {
  for (const child of category.children) {
    if (child.type != 'category') {
      continue;
    }
    child.parent_id = null;
    state.byId.set(child.id, child);
  }
  state.byId.delete(category.id);
  return {...state, byId: new Map([...state.byId])};
}

export function categoriesReducer(state = initialState, action) {
  switch (action.type) {
    case 'INSERT_CATEGORY':
      state.byId.set(action.payload.id, action.payload);
      return {
        ...state,
        lastSaved: action.payload,
        byId: new Map([...state.byId]),
      };
    case 'UPDATE_CATEGORY': {
      const existingCategory = state.byId.get(action.payload.id);
      const newCategory = Object.assign({}, existingCategory, action.payload);
      state.byId.set(action.payload.id, newCategory);
      return {
        ...state,
        lastSaved: action.payload,
        byId: new Map([...state.byId]),
      };
    }
    case 'DELETE_CATEGORY':
      return deleteCategory(state, action.payload);
    case 'UPDATE_CATEGORIES':
      return {
        ...state,
        byId: new Map([...state.byId, ...action.payload]),
      };
    case 'SET_CURRENTLY_EDITING_CATEGORY':
      return {
        ...state,
        currentlyEditing: action.payload,
      };
    case 'SET_CATEGORY_MODAL_STATE':
      return {
        ...state,
        modalState: action.payload,
      };
    case 'COMPLETE_CATEGORY':
      return completeCategory(state, action.payload);
    case 'REOPEN_CATEGORY':
      return reopenCategory(state, action.payload);
    case 'REOPEN_PROJECT':
      return reopenProject(state, action.payload);
    default:
      return state;
  }
}
